import React, { useState,useRef,useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { configData } from "../config";
import "./classes/Sales.css";
import "./classes/Main.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faCheck, faXmark, faPrint } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from 'react-helmet';
import { useReactToPrint } from "react-to-print";
import { toWords } from 'number-to-words';
import { Modal, Box, Button } from "@mui/material";

const Sales = () => {
  const products = [
    { id: 1, name: "Fanta 330", barcode: "52554654", stock: 82,unitCost: 25 },
    { id: 2, name: "Coke 500", barcode: "98765432", stock: 40 ,unitCost: 25},
    { id: 3, name: "mixed fruits" ,barcode: "10003", stock: 82,unitCost: 25 },
    { id: 4, name: "bath soap",barcode: "10004" , stock: 82 ,unitCost: 25},
    { id: 5, name: "toothpaste", barcode: "10005", stock: 82 ,unitCost: 25 },
    { id: 6, name: "shampoo", barcode: "10006", stock: 82 ,unitCost: 25 },
    { id: 7, name: "rice 1kg",  barcode: "10007" , stock: 82 ,unitCost: 25},
    { id: 8, name: "wheat flour 1kg",  barcode: "10008", stock: 82,unitCost: 25  },
    { id: 9, name: "sugar 1kg",barcode: "10009", stock: 82 ,unitCost: 25 },
    { id: 10, name: "salt packet",  barcode: "10010" , stock: 82 ,unitCost: 25},
    { id: 11, name: "cooking oil 1L",barcode: "10011" , stock: 82,unitCost: 25 },
    { id: 12, name: "milk 1L",  barcode: "10012" , stock: 82 ,unitCost: 25},
    { id: 13, name: "butter",  barcode: "10013", stock: 82 ,unitCost: 25 },
    { id: 14, name: "bread loaf",barcode: "10014", stock: 82,unitCost: 25  },
    { id: 15, name: "biscuits",  barcode: "10015", stock: 82 ,unitCost: 25 },
    { id: 16, name: "tea powder", barcode: "10016", stock: 82 ,unitCost: 25 },
    { id: 17, name: "coffee powder",  barcode: "10017", stock: 82,unitCost: 25  },
    { id: 18, name: "detergent powder", barcode: "10018", stock: 82,unitCost: 25  },
    { id: 19, name: "handwash", barcode: "10019" , stock: 82,unitCost: 25 },
    { id: 20, name: "face wash", barcode: "10020" , stock: 82 ,unitCost: 25}
  ];

  const app_url = configData.APP_URL;

  // Invoice number: persist in localStorage, auto-increment per order
  // const getNextInvoiceForDisplay = () => {
  //   const stored = localStorage.getItem("pos_invoice_number");
  //   const next = stored ? parseInt(stored, 10) + 1 : 1001;
  //   localStorage.setItem("pos_invoice_number", String(next));
  //   return next; // next invoice number for the next order
  // };
  //const [invoiceNumber, setInvoiceNumber] = useState(() => {
  //   const stored = localStorage.getItem("pos_invoice_number");
  //   return stored ? parseInt(stored, 10) + 1 : 1001; // next to use for this order
  //});
  const [invoiceNumber, setInvoiceNumber] = useState(null);
const fetchInvoiceNumber = async () => {
  try {
    const res = await fetch(app_url + "salesapi/get-invoice-number");
    const data = await res.json();

    if (data.success) {
      setInvoiceNumber(data.invoice_number);
      return data.invoice_number;
    }
  } catch (error) {
    console.error("Error fetching invoice number:", error);
  }
};
useEffect(() => {
  fetchInvoiceNumber();
}, []);
  const [companyDetail, setCompanyDetail] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [customerSearch, setCustomerSearch] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [qty, setQty] = useState(1);
  const [unitCost, setUnitCost] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [lines, setLines] = useState([]);
  const [customerType, setCustomerType] = useState("retail");
  const [paymentType, setPaymentType] = useState("cash");
  const [taxType, setTaxType] = useState("intra");												
  const [openStockModal, setOpenStockModal] = useState(false);
  const [selectedStockProduct, setSelectedStockProduct] = useState(null);
  const [stockValue, setStockValue] = useState("");
  const stockInputRef = useRef(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (openStockModal) {
      // A tiny timeout ensures the Modal is fully rendered in the DOM
      setTimeout(() => {
        stockInputRef.current?.focus();
      }, 100);
    }
  }, [openStockModal]);


  const handleAddStock = async () => {
  console.log("Add stock:", stockValue, selectedStockProduct);

  if (!stockValue || !selectedStockProduct) {
    alert("Please select product and enter stock value");
    return;
  }

  try {
    const response = await fetch(app_url+'salesapi/addstock', {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        item_id: selectedStockProduct?.id,
        quantity_stock:Number(stockValue),
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to add stock");
    }

    console.log("Success:", data);
    alert("Stock added successfully");

    // Reset UI
    setOpenStockModal(false);
    setStockValue("");

  } catch (error) {
    console.error("Error:", error);
    alert(error.message || "Something went wrong");
  }
};
  // const [cashReceived, setCashReceived] = useState("");
 // const inputRef = useRef(null);
  const inputSearchRef = useRef(null);
useEffect(() => {
  if (companyDetail && inputSearchRef.current) {
    setTimeout(() => {
      inputSearchRef.current.focus();
    }, 150);
  }
}, [companyDetail]);
  // useEffect(() => {
  //   if (searchValue === "") {
  //     inputSearchRef.current?.focus();
  //   }
  // }, [searchValue]);
  const [printType, setPrintType] = useState("receipt-58mm");
  const [showPrintPopup, setShowPrintPopup] = useState(false);
  const [invoiceNumberForPrint, setInvoiceNumberForPrint] = useState(null);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
      contentRef: contentRef,
      documentTitle: String(invoiceNumberForPrint),
      onAfterPrint: () => {
          setLines([]);
          // setCashReceived("");
          setSelectedCustomer(null);
          setCustomerSearch("");
          setSelectedProduct(null);
          setSearchValue("");
          setQty(1);
          setUnitCost(0);

          fetchInvoiceNumber();
        setTimeout(() => {
          inputSearchRef.current?.focus();
        }, 150);
      },
    });
    const getRowConfig = (type) => {
        switch (type) {
            case "invoice-a4":
            return { FIRST: 25, LAST: 9 };
            case "receipt-152mm":
            return { FIRST: 12, LAST: 5 };
            default:
            return { FIRST: 25, LAST: 9 };
        }
    };
  const onPrintClick = (size) => {
    if (lines.length === 0) return;
    // if (paymentType === "cash") {
    //   const cash = parseFloat(cashReceived) || 0;
    //   if (cash < roundedTotal) {
    //     // alert(`Cash received (₹${cash.toFixed(2)}) is less than total (₹${grandTotal.toFixed(2)}). Please enter the correct amount.`);
    //     return;
    //   }
    // }
    setPrintType(size);
    setShowPrintPopup(false);
    setTimeout(() => {
      handlePrint();
    }, 100);
  };

  const canSaveOrPrint = () => {
    if (lines.length === 0) return false;
    // if (paymentType === "cash") {
    //   const cash = parseFloat(cashReceived) || 0;
    //   return cash >= roundedTotal;
    // }
    return true;
  };

      // useEffect(() => {
      //     const handler = setTimeout(() => {
      //     if (searchValue.trim() === "") {
      //         setOptions([]);
      //         return;
      //     }
      //     setOptions(products.filter(p => p.name.includes(searchValue.toLowerCase())));
      //     }, 300);
  
      //     return () => clearTimeout(handler);
      // }, [searchValue]);
      useEffect(() => {
  if (!customerSearch.trim()) {
    setCustomerOptions([]);
    return;
  }

  const timer = setTimeout(async () => {
    try {
      const res = await fetch(
        app_url + "salesapi/getcustomerlist?query=" + customerSearch
      );
      const data = await res.json();
      setCustomerOptions(data || []);
    } catch (err) {
      console.error("Customer fetch error", err);
    }
  }, 400);

  return () => clearTimeout(timer);
}, [customerSearch]);
          useEffect(() => {
    const fetchData = async () => {
      if (searchValue.trim() === '') {
        setOptions([]); // Clear options if search is empty
        return;
      }
      try {
        const response = await fetch(app_url+'items/getproductlist?query='+searchValue+'&type='+customerType);
        const data = await response.json();
        setOptions(data); 
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const handler = setTimeout(() => {
      fetchData();
    }, 500); // Debounce for 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue,customerType]);
  const handleCustomerTypeChange = (e) => {
  setCustomerType(e.target.value);
  setOptions([]); // reset prices 
};
      
// const handleKeyDown = (e) => {
//   if (e.key !== "Enter") return;

//   e.preventDefault();
//   const input = searchValue.trim();
//   if (!input) return;

//   // Barcode scan
//   const barcodeMatch = products.find(p => p.barcode === input);
//   if (barcodeMatch) {
//     addLineFromProduct(barcodeMatch);
//     return;
//   }

//   //  Enter on selected product
//   if (selectedProduct) {
//     addLineFromProduct(selectedProduct);
//   }
// };
const handleKeyDown = async (e) => {
  if (e.key !== "Enter") return;

  e.preventDefault();

  if (selectedProduct) {
    addLineFromProduct(selectedProduct);
    return;
  }

  if (!searchValue.trim()) return;

  try {
    const res = await fetch(app_url+'items/getproductlist?query='+searchValue);
    const data = await res.json();

    if (data?.length === 1) {
      addLineFromProduct(data[0]);
    }
  } catch (err) {
    console.error(err);
  }
};

const focusProductInput = () => {
  setTimeout(() => {
    inputSearchRef.current?.focus();
  }, 50);
};

const addLineFromProduct = (product) => {
  setLines(prevLines => {
    const price = unitCost || product.unitCost;
    const quantity = Number(qty);
    const hsn_code = product.hsn_code;
    const unit = product.unit;
    const taxOnePercent = Number(product.tax_one || 0); 
    const taxTwoPercent = Number(product.tax_two || 0); 

    const lineTotal = quantity * price;

    const totalTaxPercent = taxOnePercent + taxTwoPercent;
    // const lineSubTotal = quantity * price;
    // const lineSubTotal = lineTotal / (1 + totalTaxPercent / 100);
    const lineSubTotal = parseFloat((lineTotal / (1 + totalTaxPercent / 100)).toFixed(2));

    const lineTaxOne = (lineSubTotal * taxOnePercent) / 100;
    const lineTaxTwo = (lineSubTotal * taxTwoPercent) / 100;

    const existingLine = prevLines.find(
      line => line.barcode === product.barcode
    );

    if (existingLine) {
      return prevLines.map(line => {
        if (line.barcode !== product.barcode) return line;

        const newQty = line.qty + quantity;
        const newSub = newQty * price;
        const newTaxOne = (newSub * taxOnePercent) / 100;
        const newTaxTwo = (newSub * taxTwoPercent) / 100;

        return {
          ...line,
          qty: newQty,
          hsn_code: hsn_code,
          unit: unit,
          lineSubTotal: newSub,
          lineTaxOne: newTaxOne,
          lineTaxTwo: newTaxTwo,
          lineTotal: newSub + newTaxOne + newTaxTwo
        };
      });
    }

    return [
      ...prevLines,
      {
        id: product.id,
        product: product.name,
        barcode: product.barcode,
        hsn_code: product.hsn_code,
        unit: product.unit,
        qty: quantity,
        unitCost: price,

        tax_one: taxOnePercent,
        tax_two: taxTwoPercent,

        lineSubTotal,
        lineTaxOne,
        lineTaxTwo,
        lineTotal: lineSubTotal + lineTaxOne + lineTaxTwo
      }
    ];
  });

  setSelectedProduct(null);
  setSearchValue("");
  setQty(1);
  setUnitCost(0);
  focusProductInput();
};



const updateLine = (id, field, value) => {
  setLines(prev =>
    prev.map(line => {
      if (line.id !== id) return line;

      const updated = { ...line, [field]: Number(value) };

      // const sub = updated.qty * updated.unitCost;
      // const tax1 = (sub * updated.tax_one) / 100;
      // const tax2 = (sub * updated.tax_two) / 100;

      // return {
      //   ...updated,
      //   lineSubTotal: sub,
      //   lineTaxOne: tax1,
      //   lineTaxTwo: tax2,
      //   lineTotal: sub + tax1 + tax2
      // };
      const total = updated.qty * updated.unitCost;

      // total GST %
      const totalTaxPercent = (updated.tax_one || 0) + (updated.tax_two || 0);

      // base (excluding GST)
      const sub = total / (1 + totalTaxPercent / 100);

      // split taxes from base
      const tax1 = (sub * updated.tax_one) / 100;
      const tax2 = (sub * updated.tax_two) / 100;

      return {
        ...updated,
        lineSubTotal: sub,
        lineTaxOne: tax1,
        lineTaxTwo: tax2,
        lineTotal: total // already includes GST
      };
    })
  );
};

  const removeLine = (id) => {
    setLines(prev => prev.filter(line => line.id !== id));

    setTimeout(() => {
      inputSearchRef.current?.focus();
    }, 0);
  };

  // const grandTotal = lines.reduce((sum, line) => sum + line.lineTotal, 0);
  
const subTotal = lines.reduce((s, l) => s + l.lineSubTotal, 0);
// const totalTaxOne = lines.reduce((s, l) => s + l.lineTaxOne, 0);
// const totalTaxTwo = lines.reduce((s, l) => s + l.lineTaxTwo, 0);
// const totalTax = lines.reduce(
//   (sum, line) =>
//     sum + (line.lineTaxOne || 0) + (line.lineTaxTwo || 0),
//   0
// );
const totalTaxOne = Number(lines.reduce((sum, line) => sum + (line.lineTaxOne || 0),0).toFixed(2));

const totalTaxTwo = Number(lines.reduce((sum, line) => sum + (line.lineTaxTwo || 0),0).toFixed(2));
const totalTax = totalTaxOne + totalTaxTwo;
const grandTotal = subTotal + totalTax;
// const grandTotal = parseFloat((subTotal + totalTax).toFixed(2));

const roundedTotal = Math.round(grandTotal); 
// const roundOff = (roundedTotal - grandTotal).toFixed(2);
const roundOff = Math.round((roundedTotal - grandTotal) * 100) / 100;

const optionsWithMock = [
  ...options,
  {
    id: "mock-1",
    name: "Test Product (Out of Stock)",
    unitCost: 150,
    quantity_stock: 0
  }
];
const handleSubmit = async (shouldPrint = false) => {
  if (isSubmitting) return;
  if (lines.length === 0) {
    alert("Add at least one product");
    return;
  }
  // if (paymentType === "cash") {
  //   const cash = parseFloat(cashReceived) || 0;
  //   if (cash < roundedTotal) {
  //     alert(`Cash received (₹${cash.toFixed(2)}) is less than total (₹${roundedTotal.toFixed(2)}). Please enter the correct amount.`);
  //     return;
  //   }
  // }
  setIsSubmitting(true);
  // const payload = {
  //   //order_date: new Date().toISOString(),
  //   total_amount: grandTotal,
  //   customer_type: customerType,
  //   payment_type: paymentType,
  //   cash_received: paymentType === "cash"
  //       ? parseFloat(cashReceived) || 0
  //       : 0,
  //   change_amount: paymentType === "cash"
  //       ? (parseFloat(cashReceived) - grandTotal)
  //       : 0,
  //   items: lines.map(line => ({
  //     item_id:line.id,
  //     item_name: line.product,
  //     barcode: line.barcode,
  //     quantity: String(line.qty),
  //     price: line.unitCost,
  //     total: line.lineTotal
  //   }))
  // };
 const payload = {
  total_amount: Number(roundedTotal.toFixed(2)),
  sub_total: Number(subTotal.toFixed(2)),
  sgst: Number(totalTaxOne.toFixed(2)),
  cgst: Number(totalTaxTwo.toFixed(2)),
  igst:Number(totalTax.toFixed(2)),								   
  roundoff: Number(roundOff.toFixed(2)),
  tax: Number((totalTaxOne + totalTaxTwo).toFixed(2)),

  customer_type: customerType,
  customer_id: selectedCustomer?.id || null,
  payment_type: paymentType,
  tax_type:taxType,
  // cash_received:
  //   paymentType === "cash" ? Number(cashReceived) : 0,

  // change_amount:
  //   paymentType === "cash"
  //     ? Number(cashReceived - roundedTotal)
  //     : 0,

  items: lines.map(line => ({
    item_id: line.id,
    item_name:line.product,
    barcode:line.barcode,
    quantity:String(line.qty),
    price: line.unitCost,
    sub_total: line.lineSubTotal,
    sgst: taxType === "intra" ? line.lineTaxOne : 0,
    cgst: taxType === "intra" ? line.lineTaxTwo : 0,

    tax: taxType === "inter"
      ? Number(totalTax.toFixed(2))  
      : Number((line.lineTaxOne + line.lineTaxTwo).toFixed(2)),
    total: line.lineTotal,
  }))
};
console.log(payload);
  try {
    const res = await fetch(
      app_url + "salesapi/sales-items",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      }
    );

    const data = await res.json();

    if (data.success) {
      alert("Order saved successfully");
        const currentInvoiceNumber = data.invoice_number;
        setSelectedProduct(null);
        setSearchValue("");
        setQty(1);
        setUnitCost(0);
        // setShowPrintPopup(true);
        // setInvoiceNumberForPrint(currentInvoiceNumber);
        if (shouldPrint) {
          setShowPrintPopup(true);
          setInvoiceNumberForPrint(currentInvoiceNumber);
        } else {
          setLines([]); 
        }
        await fetchInvoiceNumber();

        setTimeout(() => {
          inputSearchRef.current?.focus();
        }, 100);
    } else {
      alert("Failed to save order");
    }
  } catch (err) {
    console.error(err);
  } finally{
    setIsSubmitting(false);
  }
};

  const companydetails = async () => {
    try {
      const res = await fetch(app_url + "salesapi/showcom");
      const data = await res.json();
      if (data.company) {
        setCompanyDetail(data.company);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    companydetails();
  }, []);

  if (!companyDetail) return;

  const now = new Date();

  // const quotationDate = now.toLocaleDateString();
  const quotationDate = now.toLocaleDateString("en-GB");
  const quotationTime = now.toLocaleTimeString();

 const handleCancel = async () => {
  setLines([]);
  // setCashReceived("");
  setSelectedCustomer(null);
  setCustomerSearch("");
  setSelectedProduct(null);
  setSearchValue("");
  setQty(1);
  setUnitCost(0);

  setTimeout(() => {
    inputSearchRef.current?.focus();
  }, 100);
};

  function capitalizeWords(str) {
    return str
      .split(" ")
      .map(word => (word.toLowerCase() === "and" ? "and" : word.charAt(0).toUpperCase() + word.slice(1)))
      .join(" ");
  }

  // Usage
  const totalInWords = toWords(Math.floor(roundedTotal)); // integer part
  const decimalPart = Math.round((roundedTotal - Math.floor(roundedTotal)) * 100);

  let totalInWordsWithDecimals = decimalPart
    ? `${totalInWords} rupees and ${toWords(decimalPart)} paise`
    : `${totalInWords} rupees`;

  totalInWordsWithDecimals = capitalizeWords(totalInWordsWithDecimals);


  // Group items by tax rate
  const groupedTaxes = lines.reduce((acc, item) => {

    const taxOneRate = Number(item.tax_one || 0);
    const taxTwoRate = Number(item.tax_two || 0);
    const igstRate = Number(item.tax_one || 0) + Number(item.tax_two || 0);
    const taxable = Number(item.lineSubTotal || 0);

    const key = taxType === "inter"
    ? `${igstRate}`   //  group by combined rate
    : `${taxOneRate}_${taxTwoRate}`;

    if (!acc[key]) {
      acc[key] = {
        taxableValue: 0,
        taxOneRate: taxOneRate,
        taxTwoRate: taxTwoRate,
        igstRate: igstRate,
        taxOneAmount: 0,
        taxTwoAmount: 0,
        interTaxAmount:0,
      };
    }

    acc[key].taxableValue += taxable;
    acc[key].taxOneAmount += Number(item.lineTaxOne || 0);
    acc[key].taxTwoAmount += Number(item.lineTaxTwo || 0);
    acc[key].interTaxAmount += Number(item.lineTaxOne || 0) + Number(item.lineTaxTwo || 0);

    return acc;

  }, {});

  // Convert grouped object to array for mapping
  // const taxRows = Object.values(groupedTaxes);
  const taxRows = Object.values(groupedTaxes)
    .sort((a, b) => (a.taxOneRate + a.taxTwoRate) - (b.taxOneRate + b.taxTwoRate));

  taxRows.forEach(row => {
    row.taxableValue = Number(row.taxableValue.toFixed(2));
    row.taxOneAmount = Number(row.taxOneAmount.toFixed(2));
    row.taxTwoAmount = Number(row.taxTwoAmount.toFixed(2));
    row.interTaxAmount = Number(row.interTaxAmount.toFixed(2));
  });

  // Calculate totals
  const totalTaxable = taxRows.reduce((sum, row) => sum + row.taxableValue, 0);
  const totalCGST = taxRows.reduce((sum, row) => sum + Number(row.taxTwoAmount || 0), 0);
  const totalSGST = taxRows.reduce((sum, row) => sum + Number(row.taxOneAmount || 0), 0);
  const totalIGST = taxRows.reduce((sum, row) => sum + Number(row.interTaxAmount || 0), 0);
  const totalTaxAmount = taxType === "inter"
  ? totalIGST
  : totalCGST + totalSGST;


  const taxInWords = toWords(Math.floor(totalTaxAmount)); 
  const decimalTaxPart = Math.round((totalTaxAmount - Math.floor(totalTaxAmount)) * 100);

  let taxInWordsWithDecimals = decimalTaxPart
      ? `INR ${taxInWords} and ${toWords(decimalTaxPart)} paise`
      : `INR ${taxInWords}`;

  taxInWordsWithDecimals = capitalizeWords(taxInWordsWithDecimals);

 const { FIRST: MAX_ROWS_FIRST, LAST: MAX_ROWS_LAST } = getRowConfig(printType || "invoice-a4");

     const paginateItems = (items) => {
                        const pages = [];
                        let remaining = [...items];

                        while (remaining.length > 0) {
                            if (remaining.length > MAX_ROWS_FIRST) {
                            pages.push(remaining.slice(0, MAX_ROWS_FIRST));
                            remaining = remaining.slice(MAX_ROWS_FIRST);
                            } else {
                            if (remaining.length <= MAX_ROWS_LAST) {
                                pages.push(remaining);
                            } else {
                                // Distribute so last page is small (2–3 items)
                                const lastPageCount = Math.min(3, remaining.length);
                                const secondLastCount = remaining.length - lastPageCount;

                                pages.push(remaining.slice(0, secondLastCount)); // e.g. 5
                                pages.push(remaining.slice(secondLastCount));    // e.g. 2–3
                            }
                            break;
                            }
                        }

                        return pages;
                    };

                    const pages = paginateItems(lines);
                    let runningIndex = 0;


  return (
    <div className="purchase-order-page">
         <Helmet>
            <title>Sales</title>
         </Helmet>
    <div className="create-purchase-order-container">
    <div className="po-modal">
      <div className="po-header">
      </div>

      <div className="po-body">
        <div className="row po-summary-row">
        <div className="main-total">
          Total: ₹{roundedTotal.toFixed(2)}
        </div>
        {/* <div className="invoice-number">
          Invoice #: {invoiceNumber}
        </div> */}
        </div>

        <div className="po-options-row">
          <div className="po-option">
            <label htmlFor="customer-type">Customer Type</label>
            <select id="customer-type" value={customerType} onChange={handleCustomerTypeChange}>
              <option value="retail">Retail</option>
              <option value="wholesale">Wholesale</option>
            </select>
          </div>
          <div className="po-option" style={{ minWidth: 260 }}>
            <label>Customer</label>

            <Autocomplete
              className="customer-search"
              options={customerOptions}
              value={selectedCustomer}
              getOptionLabel={(option) => option.name}
              filterOptions={(x) => x}
              onChange={(e, value) => setSelectedCustomer(value)}
              inputValue={customerSearch}
              onInputChange={(e, value) => setCustomerSearch(value)}
              renderOption={(props, option) => (
                // <li {...props}>
                //   {option.name}
                // </li>
                <li {...props} style={{ display: "flex", flexDirection: "column", padding: "6px 10px" }}>
                  <span style={{ fontWeight: 500, fontSize: "14px", color: "#333" }}>
                    {option.name}
                  </span>
                  <span style={{ fontSize: "12px", color: "#666", marginTop: "2px" }}>
                    {option.phone_number && <span>Ph: {option.phone_number} </span>}
                    {(option.phone_number && option.gst_number) && <> | </>}
                    {option.gst_number && <span>GST: {option.gst_number}</span>}
                  </span>
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select customer"
                  size="small"
                />
              )}
            />
          </div>
          <div className="po-option">
            <label htmlFor="payment-type">Payment Type</label>
            <select id="payment-type" value={paymentType} onChange={(e) => setPaymentType(e.target.value)}>
              <option value="cash">Cash</option>
              <option value="credit">Credit</option>
            </select>
          </div>
			    <div className="po-option">
            <label htmlFor="tax">Tax</label>
            <select id="tax" value={taxType} onChange={(e) => setTaxType(e.target.value)}>
              <option value="intra">SGST + CGST</option>
              <option value="inter">IGST</option>
            </select>
          </div>  						
        {/* {paymentType === "cash" && (
          <div className="po-option po-cash-input">
            <label htmlFor="cash-received">Cash Received (₹) *</label>
            <input
              id="cash-received"
              type="number"
              step="0.01"
              min="0"
              placeholder="Enter amount"
              value={cashReceived}
              onChange={(e) => setCashReceived(e.target.value)}
              onWheel={(e) => {
                e.preventDefault();
                e.currentTarget.blur(); 
              }}
            />

            {Number(cashReceived) >= roundedTotal && roundedTotal > 0 && (
              <span className="change-display">
                Change: ₹
                {(
                  Math.round(
                    (Number(cashReceived) - Number(roundedTotal)) * 100
                  ) / 100
                ).toFixed(2)}
              </span>
            )}
          </div>
        )} */}
        </div>
      <Modal open={openStockModal} onClose={() => setOpenStockModal(false)}>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 300,
      bgcolor: "white",
      p: 3,
      borderRadius: 2,
      boxShadow: 24
    }}
  >
    {/* <h3>Add Stock</h3> */}

    <h3>{selectedStockProduct?.name}</h3>

    <TextField
      fullWidth
      inputRef={stockInputRef} 
      type="number"
      label="Enter Stock"
      value={stockValue}
      onChange={(e) => setStockValue(e.target.value)}
      sx={{ mt: 2 }}
    />

    <Button
      variant="contained"
      fullWidth
      style={{ backgroundColor: "#E03F5B" }}
      sx={{ mt: 2 }}
      onClick={handleAddStock}
    >
      Save
    </Button>
  </Box>
</Modal>
        <div className="add-line">
          <div>
            <p>Product</p>
            <div className="pos-autocomplete-search">
            <Autocomplete 
              disablePortal   
              className="pos-autocomplete"          
              options={options}
              open={open}
              onOpen={() => setOpen(true)}
              onClose={() => setOpen(false)}
              getOptionLabel={(option) => option.name}
              value={selectedProduct}
              inputValue={searchValue}
              onInputChange={(e, value) => setSearchValue(value)}
              // onChange={(e, value) => {
              //   if (!value) return;
              //   setSelectedProduct(value);
              //   setUnitCost(value.unitCost);
              // }}
              onChange={(e, value) => {
                if (!value) return;

                // KEYBOARD & MOUSE PROTECTION
                if (value.quantity_stock === 0) {
                  setSelectedStockProduct(value); // Set the product for the modal
                  setOpenStockModal(true);        // Open the modal
                  setSelectedProduct(null);       // CLEAR the selection so it doesn't add to bill
                  return;
                }

                // Normal behavior for items with stock
                setSelectedProduct(value);
                setUnitCost(value.unitCost);
              }}

              // onChange={(e, value) => {
              //   // If product has 0 stock, don't allow selection
              //   if (!value || value.quantity_stock === 0) {
              //     setSelectedProduct(null); 
              //     return;
              //   }
              //   setSelectedProduct(value);
              //   setUnitCost(value.unitCost);
              // }}
              renderOption={(props, option) => {
                const { onClick, ...otherProps } = props;
                return (
                <li
                  {...otherProps}
                onClick={(e) => {
                  if (option.quantity_stock === 0) {
                    e.stopPropagation(); // Stop MUI from selecting it
                    setSelectedStockProduct(option); // Prep the modal
                    setOpenStockModal(true); // Open the modal
                    return;
                  }
                  onClick(e); // Otherwise, do the normal selection
                }}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    opacity: option.quantity_stock === 0 ? 0.5 : 1,
                    cursor: option.quantity_stock === 0 ? "not-allowed" : "pointer"
                  }}
                >
                  <strong>{option.name}</strong>&nbsp;&nbsp;-&nbsp;
                  <span style={{ marginLeft: 10, color: "#666" }}>
                    ₹{option.unitCost}
                  </span>

                  <span
                    style={{
                      marginLeft: 10,
                      color: option.quantity_stock === 0 ? "red" : "#666"
                    }}
                  >
                    (Stock: {option.quantity_stock})
                  </span>

                {/* 3. The button is now just a visual hint since the whole row works */}
                {option.quantity_stock === 0 && (
                  <span style={{ marginLeft: 10, fontSize: '0.8rem', background: '#ff9800', color: '#fff', padding: '2px 6px', borderRadius: '4px' }}>
                    Restock
                  </span>
                )}

                </li>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  inputRef={inputSearchRef}  
                  //   inputRef={(el) => {
                  //   params.InputProps.ref(el);  
                  //   inputSearchRef.current = el;
                  // }}
                  placeholder="Search or scan barcode"
                  // onKeyDown={handleKeyDown}     
                  // onKeyDown={(e) => {
                  //   if (e.key === "Enter") {
                  //     const option = options.find(o => o.name === searchValue);

                  //     if (option?.quantity_stock === 0) {
                  //       setSelectedStockProduct(option);
                  //       setOpenStockModal(true);
                  //       e.preventDefault();
                  //       return;
                  //     }
                  //   }

                  //   handleKeyDown(e);
                  // }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {

                      // If dropdown is open and has options → let MUI handle it
                      if (open && options.length > 0) {
                        return;
                      }

                      // If dropdown is closed, check stock condition
                      if (selectedProduct?.quantity_stock === 0) {
                        e.preventDefault();
                        return;
                      }
                    }

                    // Run your custom handler
                    handleKeyDown(e);
                  }}
				  // onKeyDown={(e) => {
					//   if (e.key === "Enter") {
					// 	// If a product is already highlighted/selected by MUI, 
					// 	// let onChange handle it.
					// 	if (selectedProduct?.quantity_stock === 0) {
					// 	   e.preventDefault();
					// 	   return;
					// 	}
					//   }
					//   handleKeyDown(e);
					// }}
                  InputProps={{
                    ...params.InputProps,
                      endAdornment: (
                      <div className="pos-end-adornment">
                        {params.InputProps.endAdornment}
                      </div>
                    ),
                  }}
                />
              )}
            />
            </div>
          </div>
          <div>
            <p>Qty</p>
            <input
              type="number"
              min="1"
              value={qty}
              onChange={e => setQty(e.target.value)}
              onWheel={(e) => {
                e.preventDefault();
                e.currentTarget.blur(); 
              }}
            />
          </div>
          <div>
            <p>Unit Cost (₹)</p>
            <input
              type="number"
              step="0.01"
              value={unitCost}
              onChange={e => setUnitCost(e.target.value)}
              onWheel={(e) => {
                e.preventDefault();
                e.currentTarget.blur(); 
              }}
            />
          </div>
    <button onClick={() => selectedProduct && addLineFromProduct(selectedProduct)} className="add-line-button" style={{cursor:"pointer"}}>
  <FontAwesomeIcon icon={faPlus} /> Add Line
</button>

        </div>
        
        <div className="purchase-table">
          <div className="purchase-table-desktop">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Product</th>
                  <th>Qty</th>
                  <th>Unit Cost</th>
                  <th>Line Total</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                {lines.length > 0 ? (<>
                {lines.map((line, index) => (
                  <tr key={line.id}>
                    <td>{index + 1}</td>
                    <td>{line.product}</td>
                    <td>
                      <input
                        type="number"
                        value={line.qty}
                        onChange={e => updateLine(line.id, "qty", e.target.value)}
                        onWheel={(e) => {
                          e.preventDefault();
                          e.currentTarget.blur(); 
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={line.unitCost}
                        onChange={e =>
                          updateLine(line.id, "unitCost", e.target.value)
                        }
                        onWheel={(e) => {
                          e.preventDefault();
                          e.currentTarget.blur(); 
                        }}
                      />
                    </td>
                    <td>₹{line.lineSubTotal.toFixed(2)}</td>
                    <td><FontAwesomeIcon style={{color:"red",cursor:"pointer"}} icon={faXmark} onClick={() => removeLine(line.id)}/>
                    </td>
                  </tr>
                ))}
                </>):(<tr><td colSpan={6}>No items yet</td></tr>)}
                {/* <tr className="final-total-row">
                  <td colSpan={4} className="final-total-label">
                    Total 
                  </td>*/}
                  {/* <td className="final-total-amount">
                    ₹{grandTotal.toFixed(2)}
                  </td> */}
                 {/* <tr>
                      <td colSpan={4} className="final-total-label">Sub Total</td>
                      <td>₹{subTotal.toFixed(2)}</td>
                    </tr>
                   <tr>
                    <td colSpan={4}>SGST</td>
                    <td>₹{totalTaxOne.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td colSpan={4}>CGST</td>
                    <td>₹{totalTaxTwo.toFixed(2)}</td>
                  </tr>
                    <tr className="final-total-row">
                      <td colSpan={4} className="final-total-label bold">Total</td>
                      <td className="final-total-amount bold">
                        ₹{grandTotal.toFixed(2)}
                      </td>
                    </tr>
                </tr>*/}
              </tbody>
              <tfoot className="po-table-footer">
              <tr>
                <td colSpan={4} className="po-footer-label">Sub Total</td>
                <td className="po-footer-value">₹{subTotal.toFixed(2)}</td>
                <td></td>
              </tr>

             {taxType === "intra" ? (
                <>
              <tr>
                <td colSpan={4} className="po-footer-label">SGST</td>
                <td className="po-footer-value">₹{totalTaxOne.toFixed(2)}</td>
                <td></td>
              </tr>

              <tr>
                <td colSpan={4} className="po-footer-label">CGST</td>
                <td className="po-footer-value">₹{totalTaxTwo.toFixed(2)}</td>
                <td></td>
              </tr>
                  </>
              ) : (
                  <tr>
                    <td colSpan={4} className="po-footer-label">IGST</td>
                    <td className="po-footer-value">₹{totalTax.toFixed(2)}</td>
                    <td></td>
                  </tr>
                )}

              <tr>
                <td colSpan={4} className="po-footer-label">Round Off</td>
                <td className="po-footer-value">{roundOff.toFixed(2)}</td>
                <td></td>
              </tr>

              <tr className="po-footer-grand">
                <td colSpan={4} className="po-footer-label">Grand Total</td>
                <td className="po-footer-value">₹{roundedTotal.toFixed(2)}</td>
                <td></td>
              </tr>
            </tfoot>
            </table>
          </div>
          <div className="purchase-cards-mobile">
            {lines.length > 0 ? (
              <>
                {lines.map((line, index) => (
                  <div key={line.id} className="po-line-card">
                    <div className="po-line-card-header">
                      <span className="po-line-card-product">{line.product}</span>
                      <button type="button" className="po-line-card-remove" onClick={() => removeLine(line.id)} aria-label="Remove">
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                    <div className="po-line-card-body">
                      <div className="po-line-card-field">
                        <label>Qty</label>
                        <input
                          type="number"
                          min="1"
                          value={line.qty}
                          onChange={e => updateLine(line.id, "qty", e.target.value)}
                          onWheel={(e) => {
                            e.preventDefault();
                            e.currentTarget.blur(); 
                          }}
                        />
                      </div>
                      <div className="po-line-card-field">
                        <label>Unit Cost (₹)</label>
                        <input
                          type="number"
                          step="0.01"
                          value={line.unitCost}
                          onChange={e => updateLine(line.id, "unitCost", e.target.value)}
                          onWheel={(e) => {
                            e.preventDefault();
                            e.currentTarget.blur(); 
                          }}
                        />
                      </div>
                      <div className="po-line-card-total">
                        ₹{line.lineSubTotal.toFixed(2)}
                      </div>
                    </div>
                  </div>
                ))}
            { /*   <div className="po-cards-total">
                  <span>Total</span>
                  <span>₹{grandTotal.toFixed(2)}</span>
                </div>*/}
                <div className="po-cards-summary">
                  <div className="po-summary-row">
                    <span>Sub Total</span>
                    <span>₹{subTotal.toFixed(2)}</span>
                  </div>

                  {taxType === "intra" ? (
                <>
                  <div className="po-summary-row">
                    <span>SGST</span>
                    <span>₹{totalTaxOne.toFixed(2)}</span>
                  </div>

                  <div className="po-summary-row">
                    <span>CGST</span>
                    <span>₹{totalTaxTwo.toFixed(2)}</span>
                  </div>
                    </>
              ) : (
                   <div className="po-summary-row">
                    <span>IGST</span>
                      <span>₹{totalTax.toFixed(2)}</span>
                    </div>
                )}

                  <div className="po-summary-row">
                    <span>Round Off</span>
                    <span>₹{roundOff.toFixed(2)}</span>
                  </div>

                  <div className="po-summary-row po-summary-total">
                    <span>Total</span>
                    <span>₹{roundedTotal.toFixed(2)}</span>
                  </div>
                </div>
              </>
            ) : (
              <div className="po-cards-empty">No items yet</div>
            )}
          </div>
        </div>
        {/* <div className="total">
          <strong>Total: ₹{grandTotal.toFixed(2)}</strong>
        </div> */}

        <div className="billing-actions" style={{textAlign:"right"}}>
          <a className="cancel" onClick={handleCancel} style={{cursor:"pointer"}}>Cancel</a>&nbsp;
          <button className="save" disabled={isSubmitting} style={{ cursor: "pointer" }} onClick={() => handleSubmit(false)} >
            <FontAwesomeIcon icon={faCheck} />  {isSubmitting ? "Saving..." : "Save Order"}</button>&nbsp;
          <button
            className="save save-print"
            disabled={isSubmitting}
            style={{ cursor: "pointer", backgroundColor: "#E03F5B" }}
            // onClick={() => {
            //   canSaveOrPrint();
            //   handleSubmit();
            //   // onPrintClick();
              
            // }}
            onClick={() => {
              if (!canSaveOrPrint()) {
                alert("Cannot print. Check cash or items.");
                return;
              }
              handleSubmit(true);
            }}
          >
            <FontAwesomeIcon icon={faPrint} />  Save & Print
          </button>
        </div>
      </div>
    </div>
    </div>

    {showPrintPopup && (
      <div className="modal-overlay">
        <div className="modal-content">
          <h3 style={{margin: "2px 0px", textAlign: "center"}}>Select Print Size</h3>

          <button onClick={() => onPrintClick("receipt-58mm")}>
            Print 2"
          </button>

          {/* <button onClick={() => onPrintClick("receipt-152mm")}>
            Print 6"
          </button> */}

          <button onClick={() => onPrintClick("invoice-a4")}>
            Print A4
          </button>
             <button onClick={() => onPrintClick("invoice-a4")}>
            Print A5
          </button>

          <button onClick={() => setShowPrintPopup(false)}>
            Cancel
          </button>
        </div>
      </div>
    )}

    
    <div ref={contentRef} className={`printContent ${printType}`}>
                <>
                    <div className="receipt receipt-58mm">
                        <h2 className="center bold" style={{marginBottom: "0"}}>{companyDetail.company_name}</h2>
                        <div className="center small">
                            <span>{companyDetail.company_address}</span><br />
                            <span>GST No.: {companyDetail.gst_number}</span><br />
                            <span>Contact: {companyDetail.phone}</span>
                        </div>
                        <div className="dash-line"></div>    
                        <h2 className="center bold">Tax Invoice</h2>

                        <div className="center small">
                            <span>
                                Invoice #: {invoiceNumberForPrint}
                            </span>
                            <br />
                            Payment: {paymentType === "cash" ? "Cash" : "Credit"}
                            <br />
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <span>{quotationDate}</span>
                                <span>{quotationTime}</span>
                            </div>
                        </div>

                        <div className="dash-line"></div>

                        <div className="items-header">
                            <span>Qty</span>
                            <span>Item</span>
                            <span className="right">Price</span>
                        </div>

                        <div className="dash-line"></div>

                        {lines.map(line => (
                          <div key={line.id} className="item-row">
                            <span style={{textAlign: "center", width: "21px"}}>{line.qty}</span>
                            <span className="item-name">{line.product}</span>
                            <span className="right">₹{line.lineSubTotal.toFixed(2)}</span>
                          </div>
                        ))}

                        <div className="dash-line"></div>
                        <div className="row">
                            <span>SUBTOTAL:</span>
                            <span>₹{subTotal.toFixed(2)}</span>
                        </div>
                           {taxType === "intra" ? (
                        <>
                        <div className="row">
                            <span>SGST:</span>
                            <span>₹{totalTaxOne.toFixed(2)}</span>
                        </div>
                        <div className="row">
                            <span>CGST:</span>
                            <span>₹{totalTaxTwo.toFixed(2)}</span>
                        </div> 
                        </>
                         ) :(
                            <div className="row">
                            <span>IGST:</span>
                            <span>₹{totalTax.toFixed(2)}</span>
                        </div> )}
                        <div className="row">
                            <span><i>roundoff:</i></span>
                            <span>{roundOff.toFixed(2)}</span>
                        </div> 

                        <div className="dash-line"></div>
                        <div className="row total bold">
                            <span>TOTAL:</span>
                            <span>₹{roundedTotal.toFixed(2)}</span>
                        </div>
                        <div className="dash-line"></div>
                        <div className="dash-line"></div>

                        {/* {paymentType === "cash" && parseFloat(cashReceived) >= roundedTotal && (
                          <>
                            <div className="row">
                              <span>CASH:</span>
                              <span>₹{parseFloat(cashReceived).toFixed(2)}</span>
                            </div>
                            <div className="row">
                              <span>CHANGE:</span>
                              <span>₹{(parseFloat(cashReceived) - roundedTotal).toFixed(2)}</span>
                            </div>
                          </>
                        )} */}

                        <div className="center thanks">*** THANK YOU ***</div>

                    </div>


            {/* 152mm receipt & A4 invoice */}
            {pages.map((pageItems, pageIndex) => {
           const isLastPage = pageIndex === pages.length - 1;

          const maxRows = isLastPage ? MAX_ROWS_LAST : MAX_ROWS_FIRST;
          const emptyRows = Math.max(0, maxRows - pageItems.length);
          const startIndex = runningIndex;
          runningIndex += pageItems.length;

            return (
            <div  key={pageIndex} className="invoice-a4">
                <div style={{ fontSize: "14px", padding: "10px", textAlign: "center" }}>Tax Invoice</div>
                <table className="invoice-table">

                    <thead>
                    {/* Company Section */}
                    <tr>
                        <td style={{ width: "60%", verticalAlign: "top" }}>
                            <table className="no-border-top no-border-left no-border-bottom" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <td style={{fontWeight: "700"}}>{companyDetail.company_name}</td>
                                    </tr>
                                    <tr>
                                        <td>{companyDetail.company_address}</td>
                                    </tr>
                                    <tr>
                                        <td>GSTIN: {companyDetail.gst_number}</td>
                                    </tr>
                                    <tr>
                                        <td>Contact: {companyDetail.phone}</td>
                                    </tr>
                                    {/* <tr>
                                        <td>PAN No.:</td>
                                    </tr> */}
                                </thead>
                            </table>
                        </td>

                        <td style={{ width: "40%" }}>
                            <table className="no-border-top no-border-left no-border-right no-border-bottom" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <td>Date: {quotationDate}</td>
                                    </tr>
                                    <tr>
                                        <td>Invoice #: {invoiceNumberForPrint}</td>
                                    </tr>
                                    {/* <tr>
                                        <td>PAN No:</td>
                                    </tr> */}
                                    <tr>
                                        <td>Payment Mode: {paymentType === "cash" ? "Cash" : "Credit"}</td>
                                    </tr>
                                     <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                </thead>
                            </table>
                        </td>
                    </tr>

                    {/* Billing Section */}

                    <tr>
                        <td colSpan={2}>
                            <table className="no-border-bottom no-border-left no-border-right" style={{ width: "100%" }}>
                              {selectedCustomer && <>
                                <thead>
                                    <tr><td>Billing To</td></tr>
                                      <tr>
                                        <td>
                                          <span style={{fontWeight: "700"}}>{selectedCustomer.name && <>{selectedCustomer.name}</>}</span>
                                     
                                          <span>{selectedCustomer.address && <>{selectedCustomer.address}</>}</span>&nbsp;
                                     
                                          <span>{selectedCustomer.gst_number && <>| GSTIN: {selectedCustomer.gst_number}</>}</span>&nbsp;
                                     
                                          <span>{selectedCustomer.phone_number && <>| Contact: {selectedCustomer.phone_number}</>}</span>&nbsp;
                                     
                                          <span>{selectedCustomer.email && <>| Email ID: {selectedCustomer.email}</>}</span>
                                          </td>
                                      </tr>
                                </thead>
                              </>}
                            </table>
                        </td>
                        {/* <td style={{ width: "40%" }}></td> */}
                    </tr>

                    {/* Items Table */}
                    <tr>
                        <td colSpan="2">

                        <table className="no-border-left no-border-right invoice-main-table no-border-bottom-th" style={{ width: "100%", padding: "0px" }}>
                                 <colgroup>
                                            <col style={{width: "5%"}} />
                                            <col style={{width: "33%"}} />
                                            <col style={{width: "13%"}} />
                                            <col style={{width: "10%"}} />
                                            <col style={{width: "7%"}} />
                                            <col style={{width: "15%"}} />
                                            <col style={{width: "17%"}} />
                                </colgroup>
                            <thead>
                                <tr>
                                    <th style={{fontSize: "12px"}}>Sl No.</th>
                                    <th>Description of Goods</th>
                                    <th>HSN/SAC</th>
                                    {/* <th>GST</th> */}
                                    <th>Qty</th>
                                    <th>per</th>
                                    <th>Rate</th>
                                    {/* <th>Disc. %</th> */}
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            </table>
                                    </td>
                                </tr>
                                    </thead>
                                    
                            <tr>
                                <td colSpan="2">
                                <table className="no-border-left no-border-right no-border-top no-border-bottom invoice-main-table" style={{ width: "100%", padding: "0px" }}>
                                    <colgroup>
                                      <col style={{width: "5%"}} />
                                      <col style={{width: "33%"}} />
                                      <col style={{width: "13%"}} />
                                      <col style={{width: "10%"}} />
                                      <col style={{width: "7%"}} />
                                      <col style={{width: "15%"}} />
                                      <col style={{width: "17%"}} />
                                    </colgroup>

                            <tbody>
                                {pageItems.map((line, idx) => (
                                  <tr key={line.id}>
                                    <td>{startIndex + idx + 1}</td>
                                    <td style={{fontWeight: "700", textAlign: "left"}}>
                                      {line.product}
                                    </td>
                                    <td>{line.hsn_code}</td>
                                    {/* <td>
                                      {(Number(line.tax_one || 0) + Number(line.tax_two || 0)).toFixed(2)}%
                                    </td> */}
                                    <td>{line.qty}</td>
                                    <td>{line.unit}</td>
                                    <td>
                                      ₹{line.qty ? (line.lineSubTotal / line.qty).toFixed(2) : "0.00"}
                                    </td>
                                    <td>₹{Number(line.lineSubTotal || 0).toFixed(2)}</td>
                                  </tr>
                                ))}
                                {Array.from({ length: emptyRows }).map((_, i) => (
                                  <tr key={`empty-${i}`}>
                                    <td>&nbsp;</td>
                                    <td></td><td></td>
                                    <td></td><td></td><td></td><td></td>
                                  </tr>
                                ))}
                                   </tbody>
                                    
                                </table>
                                
                                </td>
                            </tr>
                                {/* <tr></tr> */}
                                {isLastPage && (
                                   <tfoot>
                                  <tr><td colSpan={2}>
                                  <table className="invoice-main-table no-border-left no-border-right no-border-top" style={{width:'100%'}}>
                                      <colgroup>
                                          <col style={{width: "5%"}} />
                                          <col style={{width: "33%"}} />
                                          <col style={{width: "13%"}} />
                                          <col style={{width: "10%"}} />
                                          <col style={{width: "7%"}} />
                                          <col style={{width: "15%"}} />
                                          <col style={{width: "17%"}} />
                                      </colgroup>
                                 {taxType === "intra" ? (
                                <>      
                                <tr>
                                    <td></td>
                                    <td style={{fontWeight: "700", textAlign: "right"}}>SGST</td>
                                    <td></td><td></td><td></td><td></td>
                                    <td>₹{totalTaxOne.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td style={{fontWeight: "700", textAlign: "right"}}>CGST</td>
                                    <td></td><td></td><td></td><td></td>
                                    <td>₹{totalTaxTwo.toFixed(2)}</td>
                                </tr>
                                </>
                                ) : (
                                 <tr>
                                    <td></td>
                                    <td style={{fontWeight: "700", textAlign: "right"}}>IGST</td>
                                    <td></td><td></td><td></td><td></td>
                                    <td>₹{totalTax.toFixed(2)}</td>
                                </tr>)}
                                <tr>
                                    <td></td>
                                    <td style={{fontWeight: "700", textAlign: "right"}}><i>Roundoff</i></td>
                                    <td></td><td></td><td></td><td></td>
                                    <td>{roundOff.toFixed(2)}</td>
                                </tr>
                                <tr style={{ fontWeight: "bold", borderTop: "1px solid #111" }}>
                                    <td></td>
                                    <td>Total</td>
                                    <td></td><td></td><td></td><td></td>
                                    <td>₹{roundedTotal.toFixed(2)}</td>
                                </tr>
                                 </table>
                            </td></tr>

                    <tr>
                        <td colSpan={2} style={{padding: "3px"}}>
                        <div>Amount Chargeable (in words)</div>
                        <div style={{fontWeight: "700"}}>{totalInWordsWithDecimals} only</div>
                        </td>
                    </tr>

                            <>     
                            <tr>
                                <td colSpan="2">
                                    <table className="invoice-tax-table no-border-right no-border-left" style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead>
                                            {taxType === "intra" ? (
                                              <>
                                                <tr>
                                                <th rowSpan={2}>Taxable<br />Value</th>
                                                <th colSpan={2}>CGST</th>
                                                <th colSpan={2}>SGST/UTGST</th>
                                                <th rowSpan={2}>Total<br />Tax Amount</th>
                                            </tr>
                                            <tr>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                            </tr>
                                            </>
                                            ) : (
                                                <>
                                                <tr>
                                                <th rowSpan={2}>Taxable<br />Value</th>
                                                <th colSpan={2}>IGST</th>
                                                <th rowSpan={2}>Total<br />Tax Amount</th>
                                            </tr>
                                            <tr>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                            </tr>
                                            </>
                                            )}
                                        </thead>
                                        <tbody>
                                            {taxRows.map((row, idx) => (
                                              taxType === "intra" ? (
                                                <tr key={idx}>
                                                    <td style={{textAlign: "right" }}>
                                                    ₹{row.taxableValue.toFixed(2)}
                                                    </td>
                                                    <td style={{textAlign: "center" }}>
                                                    {row.taxTwoRate}%
                                                    </td>
                                                    <td style={{textAlign: "right" }}>
                                                    ₹{row.taxTwoAmount.toFixed(2)}
                                                    </td>
                                                    <td style={{textAlign: "center" }}>
                                                    {row.taxOneRate}%
                                                    </td>
                                                    <td style={{textAlign: "right" }}>
                                                    ₹{row.taxOneAmount.toFixed(2)}
                                                    </td>
                                                    <td style={{textAlign: "right" }}>
                                                    ₹{(row.taxOneAmount + row.taxTwoAmount).toFixed(2)}
                                                    </td>
                                                </tr>
                                              ) : (
                                                 <tr key={idx}>
                                                    <td style={{textAlign: "right" }}>
                                                    ₹{row.taxableValue.toFixed(2)}
                                                 </td>
                                                  <td style={{ textAlign: "center" }}>
                                                    {row.igstRate}%
                                                  </td>
                                                  <td style={{ textAlign: "right" }}>
                                                    ₹{row.interTaxAmount.toFixed(2)}
                                                  </td>
                                                  <td style={{textAlign: "right" }}>
                                                    ₹{(row.taxOneAmount + row.taxTwoAmount).toFixed(2)}
                                                  </td>
                                                </tr>
                                              )
                                            ))}

                                            {/* Total row */}
                                            
                                            <tr style={{ fontWeight: "bold" }}>
                                                <td style={{textAlign: "right" }}>
                                                    Total: ₹{totalTaxable.toFixed(2)}
                                                </td>
                                                {taxType === "intra" ? (<>
                                                <td></td>
                                                <td style={{textAlign: "right" }}>
                                                    ₹{totalCGST.toFixed(2)}
                                                </td>
                                                <td></td>
                                                <td style={{textAlign: "right" }}>
                                                    ₹{totalSGST.toFixed(2)}
                                                </td></>) : (<>
                                                <td></td>
                                                <td style={{textAlign: "right" }}>
                                                    ₹{totalIGST.toFixed(2)}
                                                </td>
                                                </>)}
                                                <td style={{textAlign: "right" }}>
                                                    ₹{totalTaxAmount.toFixed(2)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>

                            <tr>
                                <td colSpan={2} style={{height: "50px", padding: "3px"}}>
                                    <div>Tax Amount (in words)</div>
                                    <div style={{fontWeight: "700"}}>{taxInWordsWithDecimals} only</div>
                                </td>
                            </tr>
                        </>  

                    <tr>
                        <td colSpan={2}>
                            <table style={{ width: "100%", tableLayout: "fixed" }} className="no-border-left no-border-right">
                                <colgroup>
                                    <col style={{ width: "50%" }} />
                                    <col style={{ width: "50%" }} />
                                </colgroup>

                                <tbody>
                                    <tr>
                                    <td style={{padding: "3px 10px 3px 3px"}}>
                                        <span style={{fontSize: "13px", textDecoration: "underline"}}>Declaration</span><br />
                                        <span>We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.</span>
                                    </td>
                                    {companyDetail.account_no && 
                                      <td>
                                          <div>Company's Bank Details</div>
                                          <div>Bank Name: {companyDetail.bank_name && <span style={{fontWeight: "700"}}>{companyDetail.bank_name}</span>}</div>
                                          <div>A/c No.: {companyDetail.account_no && <span style={{fontWeight: "700"}}>{companyDetail.account_no}</span>}</div>
                                          <div>Branch & IFS Code: <span style={{fontWeight: "700"}}>{companyDetail.branch && <span>{companyDetail.branch}</span>}
                                          {companyDetail.ifsc && <span> & {companyDetail.ifsc}</span>}</span></div>
                                      </td>
                                    }
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>

                    {/* Footer */}
                    <tr>
                        <td colSpan={2}>
                            <table style={{ width: "100%", tableLayout: "fixed" }} className="no-border">
                                <colgroup>
                                    <col style={{ width: "50%" }} />
                                    <col style={{ width: "50%" }} />
                                </colgroup>

                                <tbody>
                                    <tr>
                                    <td style={{ height: "80px" }}>
                                        Customer's Seal and Signature
                                    </td>

                                    <td style={{ textAlign: "right", height: "80px", borderLeft: "1px solid #111"}}>
                                        <div style={{display:"flex", flexDirection:"column", height:"100%"}}>
                                            <div style={{fontWeight: "700"}}>for {companyDetail.company_name}</div>
                                            <div style={{ marginTop: "auto" }}>Authorised Signatory</div>
                                        </div>
                                    </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>

                    </tfoot>)}

                </table>
            </div>)})}
        </>
    </div>
    </div>
    
  );
};

export default Sales;